<template>
  <div>
    <label class="text-sm" v-if="!!label"> {{ label }}</label>
    <v-select :multiple="multiple" class="w-full" :placeholder="placeholder" v-model="inputVal" :options="paginated" :autocomplete="autocomplete" :filterable="true" @open="onOpen" @close="onClose">
      <template #list-footer>
        <li ref="load" class="loader" s v-show="hasNextPage"></li>
      </template>
    </v-select>
  </div>
  <!-- <span class="text-danger text-sm" /> -->
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'dynamic-select',
  components: {
    vSelect
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    extra: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  data() {
    return {
      observer: null,
      limit: 25,
      page: 1,
      search: '',
      vOptions: [...this.extra, ...this.options],
      total: 0
    }
  },
  async mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    await this.getOptions()
  },
  computed: {
    inputVal: {
      get() {
        return this.vOptions.find(item => item.value === this.value)
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    filtered() {
      return this.vOptions
    },
    paginated() {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage() {
      return true
    }
  },
  methods: {
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    // fetchOptions(search, loading) {
    //   loading(true)
    //   this.search = search
    //   this._debounce((...args) => this.getOptions(...args), loading)
    // },
    // _debounce(callback, ...args) {
    //   clearTimeout(this.timeoutId)
    //   this.timeoutId = setTimeout(() => {
    //     this.timeoutId = null
    //     this.$nextTick(() => {
    //       callback(...args)
    //     })
    //   }, 400)
    // },
    async getOptions(loading = null) {
      const payload = {
        search: this.search
      }
      if (this.action) {
        this.$store
          .dispatch(this.action, payload)
          .then(response => {
            if (loading) loading(false)
            this.vOptions = [...this.extra, ...response.data]
          })
          .catch(() => {
            if (loading) loading(false)
            // this.$vs.notify({
            //   title: 'Error',
            //   text: error,
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'danger'
            // })
          })
      }
    }
  }
}
</script> 
 
